export * from "./atoms";
export * from "./organisms";
export * from "./messages";

import { DepartmentAtoms } from "./atoms";
import { DepartmentMessages } from "./messages";
import { DepartmentOrganisms } from "./organisms";

export const DepartmentComponents = [...DepartmentAtoms, ...DepartmentOrganisms, ...DepartmentMessages];
